import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { TimeplanUnitRecord } from '../entities/records';
import * as selectors from '../entities/TimeplanUnit/selectors';

function mapStateToProps(state, { timeplanUnitIds }) {
  return {
    timeplanUnits: selectors.timeplanUnitsByIds(state, timeplanUnitIds),
  };
}

export default compose(
  setPropTypes({
    timeplanUnitIds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    timeplanUnits: PropTypes.arrayOf(PropTypes.instanceOf(TimeplanUnitRecord)),
  }),
)(mapStateToProps);
